// extracted by mini-css-extract-plugin
var _1 = "PresenceAvatar-module__container--ya8Fv";
var _2 = "PresenceAvatar-module__cursorColor1--CFvzW";
var _3 = "PresenceAvatar-module__cursorColor2--qEneC";
var _4 = "PresenceAvatar-module__cursorColor3--xc1BK";
var _5 = "PresenceAvatar-module__cursorColor4--p_WzS";
var _6 = "PresenceAvatar-module__cursorColor5--KTgiJ";
var _7 = "PresenceAvatar-module__cursorColor6--W5UDy";
var _8 = "PresenceAvatar-module__editing--ew7np";
export { _1 as "container", _2 as "cursorColor1", _3 as "cursorColor2", _4 as "cursorColor3", _5 as "cursorColor4", _6 as "cursorColor5", _7 as "cursorColor6", _8 as "editing" }
